import { render, staticRenderFns } from "./ComplianceIndValue.vue?vue&type=template&id=5e5ae6d1"
import script from "./ComplianceIndValue.vue?vue&type=script&lang=js"
export * from "./ComplianceIndValue.vue?vue&type=script&lang=js"
import style0 from "./ComplianceIndValue.vue?vue&type=style&index=0&id=5e5ae6d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports